import styles from "./MainScreen.module.scss";
import List from "./components/list/List";
import RatingModal from "../../common/components/ratingModal/RatingModal";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";
import { useMainScreen } from "./useMainScreen";
import { AppPromotion } from "../../common/components/appPromotion/AppPromotion";

export default function MainScreen() {
  const {
    list,
    categoryList,
    promoList,
    selectedCategory,
    setSelectedCategory,
    getCategoryName,
    variant,
  } = useMainScreen();
  

  return (
    <div className={styles.container}>
      <PageMeta />
      <List
        variant={variant}
        promoList={promoList}
        categoryList={categoryList}
        setSelectedCategory={setSelectedCategory}
        selectedCategory={selectedCategory}
        getCategoryName={getCategoryName}
      />
      <RatingModal />
    </div>
  );
}
